import NavBreadcrumb from './nav_breadcrumb'

export { NavBreadcrumb }
